import { Collapse } from "antd";
import * as React from "react";
import { Dataset, Organization } from "src/@types/ImpiricaPlatformApi";
import { useHistory } from "react-router-dom";
import DatasetContext from "src/context/DatasetContext";
import { Icon } from "src/components/icons/Icon";
import { ChevronRight } from "lucide-react";
import { useContext } from "react";
import { useApi } from "src/Api/useApi";
import neurapulseLogo from "src/assets/images/neurapulse/neurapulse-logo-icon-blue.png";
import styles from "./OrgDatasetAccordionItems.module.css";

// @ts-ignore
import "./CustomCollapse.css";
import clsx from "clsx";

interface IProps {
	orgDatasetRows: OrgDatasetRow[];
	currentUser: CurrentUserDTO;
}

export type OrgDatasetRow = {
	org: Organization;
	datasets: Dataset[];
};
const { Panel } = Collapse;

const OrgDatasetAccordionItems = ({ currentUser, orgDatasetRows }: IProps) => {
	const { updateCurrentDataset, updateCurrentOrganization } =
		useContext(DatasetContext);

	const { datasetsClient } = useApi();
	const history = useHistory();

	const updateContext = async (org: Organization, dataset: Dataset) => {
		updateCurrentOrganization(org.id);

		if (datasetsClient) {
			//fetch Dataset details
			const datasetWithDetails = await datasetsClient.fillDetails(
				org.id,
				dataset.id
			);

			updateCurrentDataset(datasetWithDetails as DatasetDTO);

			// Navigate
			history.push(`/organizations/${org.id}/datasets/${dataset.id}/clients`);
		}
	};

	const defaultActiveKey = currentUser.tenantId;

	return (
		<div className={styles.outerContainer}>
			{orgDatasetRows.map((orgDatasetRow) => (
				<Collapse
					key={orgDatasetRow.org.id}
					accordion
					className="custom-collapse"
					defaultActiveKey={defaultActiveKey}
				>
					<Panel
						header={orgDatasetRow.org.name}
						key={orgDatasetRow.org.id}
						disabled={orgDatasetRow.datasets.length === 0}
						showArrow={orgDatasetRow.datasets.length === 0 ? false : true}
					>
						{orgDatasetRow.datasets.map((dataset) => {
							if (dataset === null || dataset === undefined) {
								return <></>;
							}
							return (
								<div
									className={styles.datasetContainer}
									key={dataset.id}
									onClick={async () =>
										await updateContext(orgDatasetRow.org, dataset)
									}
								>
									{dataset.neurapulseProjectId && (
										<img
											src={neurapulseLogo}
											alt="Neurapulse Logo"
											className={styles.neurapulseLogo}
										/>
									)}
									<div className={styles.datasetAndChevron}>
										{dataset.name}
										<span>
											<Icon icon={ChevronRight} />
										</span>
									</div>
								</div>
							);
						})}
					</Panel>
				</Collapse>
			))}
		</div>
	);
};
export default OrgDatasetAccordionItems;
